export default __webpack_public_path__ + "static/media/S-PU1H5_Gallery_1.0c4890af.jpg";